// extracted by mini-css-extract-plugin
module.exports = {"container":"questions-list_container__3bPB0","title_name":"questions-list_title_name__20psB","no_questions__wrapper":"questions-list_no_questions__wrapper__bB1gC"};